import { RouteAuthenticationRequirement, RouteItem } from '@cksoftware/react-base';
import { Layout } from '../components/layout/layout';
import { AppRoles } from '../constants/appRoles';
import { ApplicationRoutes } from '../constants/appRoutes';

export const AdminRouteItem: RouteItem = {
  text: 'Admin',
  authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
  path: ApplicationRoutes.admin.root,
  allowedRoles: [AppRoles.Admin],
  layout: <Layout />,
  async lazy() {
    const component = await import('../features/userAdmin/ManageUsers');
    return { Component: component.ManageUsers };
  }
};

export const AdminNavItems: RouteItem = {
  text: 'Admin',
  authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
  allowedRoles: [AppRoles.UserAdmin, AppRoles.Admin],
  layout: <Layout />,
  subItems: [
    {
      text: 'Manage Users',
      authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
      path: ApplicationRoutes.admin.users,
      allowedRoles: [AppRoles.UserAdmin],
      async lazy() {
        const component = await import('../features/userAdmin/ManageUsers');
        return { Component: component.ManageUsers };
      }
    },
    {
      text: 'Manage Advertisements',
      authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
      path: ApplicationRoutes.admin.advertisements,
      allowedRoles: [AppRoles.AdvertisementAdmin],
      async lazy() {
        const component = await import('../features/advertisement/ManageAdvertisements');
        return { Component: component.ManageAdvertisements };
      }
    },
    {
      text: 'Manage Banners',
      authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
      path: ApplicationRoutes.admin.banners,
      allowedRoles: [AppRoles.BannerAdmin],
      async lazy() {
        const component = await import('../features/bannerAdmin/ManageBanners');
        return { Component: component.ManageBanners };
      }
    },
    {
      text: 'Manage Contact Page Entries',
      authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
      path: ApplicationRoutes.admin.contactPageEntries,
      allowedRoles: [AppRoles.Admin],
      async lazy() {
        const component = await import('../features/contactPageEntries/ManageContactPageEntries');
        return { Component: component.ManageContactPageEntries };
      }
    },
    {
      text: 'Manage Listing Markets',
      authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
      path: ApplicationRoutes.crm.listingMarkets,
      allowedRoles: [AppRoles.Admin],
      async lazy() {
        const component = await import('../features/listingMarkets/ManageListingMarkets');
        return { Component: component.ManageListingMarkets };
      }
    },
    {
      text: 'Manage Auction Defaults',
      authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
      path: ApplicationRoutes.crm.auctionDefaults,
      allowedRoles: [AppRoles.Admin],
      async lazy() {
        const component = await import('../features/auctionDefaults/ManageAuctionDefaults');
        return { Component: component.ManageAuctionDefaults };
      }
    }
  ]
};
